import React, { useState } from 'react';
import { Check, Star, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const packs = [{
  id: 'inicial',
  title: 'PACK INICIAL',
  subtitle: 'Cerrajeria Hogar+Automotriz en pdf + 10 bonus de regalos',
  price: '$19.990',
  image: 'https://cdn.magicpatterns.com/uploads/aWrD6baYqU9eoSSajd3zmn/12_en_1.webp',
  features: ['✅ Cerrajería para el Hogar + Automotriz', '🎁 10 Bonus Exclusivos', '⚡ Acceso Inmediato', '📱 Material Digital', '⚡ Acceder Ahora'],
  buttonText: 'Comprar Pack Inicial',
  checkoutUrl: 'https://www.digiital-factory.shop/cart/48558863417593:1'
}, {
  id: 'completo',
  title: 'PACK COMPLETO',
  subtitle: '3 libros en pdf + 10 bonus de regalos + detailing completo',
  price: '$22.990',
  image: 'https://cdn.magicpatterns.com/uploads/fsqb7udX14LCtXo4pQMzcZ/13_en_1.webp',
  features: ['✅ Cerrajería para el Hogar + Automotriz + Detailing', '🎁 10 Bonus Exclusivos', '⚡ Acceso Inmediato', '📱 Material Digital', '⚡ Acceder Ahora'],
  buttonText: 'Quiero el Pack Completo',
  badge: 'Más elegido',
  checkoutUrl: 'https://www.digiital-factory.shop/cart/48558867415289:1'
}];
export function PricingPacks() {
  const [selectedPackId, setSelectedPackId] = useState('completo');
  const selectedPack = packs.find(p => p.id === selectedPackId);
  return <section id="pricing" className="py-24 bg-[#fdfaf6] px-4 pt-[40px] pb-[40px]" data-id="element-102">
      <div className="max-w-5xl mx-auto space-y-[0px]" data-id="element-103">
        <div className="text-center mb-16" data-id="element-104">
          <h2 className="text-4xl font-bold text-[#5d4037] mb-4" data-id="element-105">
            Elegí tu pack y empezá hoy
          </h2>
          <p className="text-[#8b6b61] text-lg" data-id="element-106">
            ⚠️ Promoción disponible por tiempo limitado o hasta agotar cupos.
          </p>
        </div>

        <div className="grid gap-4 mb-12" data-id="element-107">
          {packs.map(pack => {
          const isSelected = selectedPackId === pack.id;
          return <motion.div key={pack.id} layout onClick={() => setSelectedPackId(pack.id)} className={`relative overflow-hidden bg-white rounded-[2.5rem] transition-all cursor-pointer border-2 ${isSelected ? 'border-[#3b82f6] shadow-2xl ring-4 ring-[#3b82f6]/10' : 'border-transparent shadow-lg hover:shadow-xl opacity-90 hover:opacity-100'}`} data-id="element-108">
                {pack.badge && <div className="absolute top-0 right-12 px-5 py-1.5 rounded-b-2xl font-bold flex items-center gap-1.5 z-20 shadow-md text-[14px] text-[#160101] bg-[#F9F910]" data-id="element-109">
                    <Star className="w-3.5 h-3.5 fill-current" data-id="element-110" /> {pack.badge}
                  </div>}

                <div className="p-6 md:p-8" data-id="element-111">
                  <div className="flex items-center justify-between gap-6" data-id="element-112">
                    <div className="flex-grow" data-id="element-113">
                      <h3 className={`text-xl md:text-2xl font-black transition-colors ${isSelected ? 'text-[#3b82f6]' : 'text-[#5d4037]'}`} data-id="element-114">
                        {pack.title}
                      </h3>
                      <p className="text-sm md:text-base text-[#8b6b61] font-bold" data-id="element-115">
                        {pack.subtitle}
                      </p>
                      <div className="mt-1" data-id="element-116">
                        <span className="text-2xl md:text-3xl font-black text-[#5d4037]" data-id="element-117">
                          {pack.price}
                        </span>
                      </div>
                    </div>

                    <div className="flex items-center gap-4" data-id="element-118">
                      <div className={`w-12 h-6 rounded-full border-2 transition-all duration-300 flex items-center shadow-inner px-1 ${isSelected ? 'bg-[#3b82f6] border-[#2563eb]/20 shadow-[0_0_15px_rgba(59,130,246,0.3)]' : 'bg-gray-300 border-gray-400/20'}`} data-id="element-119">
                        <motion.div animate={{
                      x: isSelected ? 20 : 0
                    }} transition={{
                      type: 'spring',
                      stiffness: 500,
                      damping: 30
                    }} className={`w-4 h-4 rounded-full bg-white shadow-sm`} data-id="element-120" />
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Single Reveal Area Below All Packs */}
        <AnimatePresence mode="wait" data-id="element-121">
          {selectedPack && <motion.div key={selectedPack.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4
        }} className="bg-white rounded-[2.5rem] shadow-2xl border-2 border-[#3b82f6]/20 overflow-hidden" data-id="element-122">
              <div className="p-6 md:p-12 pl-[24px] pr-[24px] pt-[15px] pb-[15px] space-y-[16px]" data-id="element-123">
                <div className="grid md:grid-cols-2 items-center gap-[30px]" data-id="element-124">
                  <motion.div initial={{
                x: -20,
                opacity: 0
              }} animate={{
                x: 0,
                opacity: 1
              }} transition={{
                delay: 0.2
              }} data-id="element-125">
                    <div className="flex flex-col mb-6" data-id="element-126">
                      <h4 className="text-2xl font-black text-[#5d4037]" data-id="element-127">
                        ¿Qué incluye tu {selectedPack.title}?
                      </h4>
                      <span className="text-3xl font-black mt-1 text-[#0DA112]" data-id="element-128">
                        {selectedPack.price}
                      </span>
                    </div>
                    <ul className="mb-10 space-y-[0px]" data-id="element-129">
                      {selectedPack.features.map((feature, i) => <li key={i} className="flex items-start gap-3 text-[#5d4037] font-semibold text-lg" data-id="element-130">
                          <span data-id="element-131">{feature}</span>
                        </li>)}
                    </ul>
                    <a href={selectedPack.checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full h-[70px] flex items-center justify-center rounded-2xl font-black text-xl bg-[#d4af37] hover:bg-[#c4a030] text-white transition-all shadow-xl transform hover:scale-[1.02] active:scale-95 px-8" data-id="element-132">
                      {selectedPack.buttonText}
                    </a>
                  </motion.div>

                  <motion.div initial={{
                scale: 0.95,
                opacity: 0
              }} animate={{
                scale: 1,
                opacity: 1
              }} transition={{
                delay: 0.3
              }} className="relative flex flex-col items-center justify-center gap-8" data-id="element-133">
                    <img src={selectedPack.image} alt={selectedPack.title} className="w-full h-auto block drop-shadow-2xl scale-110" style={{
                  maxHeight: '600px',
                  objectFit: 'contain'
                }} data-id="element-134" />
                    <img src="https://cdn.magicpatterns.com/uploads/wAWkVKnDXTuTzttFjaLmJN/mercado_lider.webp" alt="MercadoLíder Platinum" className="w-full h-auto block" data-id="element-135" />
                  </motion.div>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </section>;
}